module.exports = __webpack_public_path__ + "img/skillsC-1.7a9b9238.png";